import { DropdownOption } from 'components/dropdown/component'
import * as Validation from 'components/validation/validations'
import { RasaContext } from 'context'
import { RasaReactComponent } from 'generic/rasaReactComponent'
import React from 'react'
import * as GenerativeAI from 'shared_server_client/types/generative_ai'
import './_styles.scss'
import {PaperPlaneIcon} from "../../icons/paper-plane";
import { streamArticleResponse, streamChatResponse } from './data'
import { AiAssistant } from 'components/icons/aiAssistant'
import { Loading } from 'components/loading'
import { DEFAULT_PROMPTS, Prompt } from './constants'
import { isTruthy, tryParseJSON } from 'generic/utility'
import { Badge } from 'reactstrap'
import { isInCutoffWindow } from 'shared/data-layer/issues'
import * as Constants from './constants'
import { Article } from '../types'
import { NORMAL_BOOSTED_BOOST_LEVEL } from 'shared_server_client/constants'

const ModelTypeOptions: DropdownOption[] = [
  { description: 'default', key: '' },
  { description: 'mistral-tiny', key: 'mistral|mistral-tiny' },
  { description: 'mistral-small', key: 'mistral|mistral-small' },
  { description: 'openai-3.5', key: 'openai|gpt-3.5-turbo' },
  { description: 'openai-4.0', key: 'openai|gpt-4-1106-preview' },
]

interface State {
  aiConfirmationType?: Constants.AIConfirmationType,
  activeCommunity: any,
  articles: Article[],
  categories: GenerativeAI.Keyword[],
  chatInputPlaceholder: string,
  community: string,
  error?: string,
  found: boolean,
  input: string,
  isLoading: boolean,
  message: string,
  newPrompts: GenerativeAI.ChatPrompt[],
  topics: string,
  sessionId: string,
  summary: string,
  showDefaultPrompt: boolean,
  showStreamLoader: boolean,
  streamMessage: string,
  suggestedArticles: Article[],
  model: DropdownOption,
  prompts: GenerativeAI.ChatPrompt[],
  aiJsonResponse: string,
  pickStreamKey: boolean,
  currentStreamKey: string,
  showsummaryStream: boolean,
  showsuggestedArticlesStream: boolean,
}

const newState: State = {
  aiConfirmationType: null,
  activeCommunity: {},
  articles: [],
  categories: [],
  chatInputPlaceholder: '',
  community: '',
  found: true,
  isLoading: false,
  input: '',
  message: '',
  newPrompts: [],
  topics: '',
  sessionId: '',
  summary: '',
  aiJsonResponse: '',
  showDefaultPrompt: true,
  showStreamLoader: false,
  streamMessage: '',
  suggestedArticles: [],
  model: ModelTypeOptions[0],
  prompts: [],
  pickStreamKey: false,
  currentStreamKey: '',
  showsummaryStream: true,
  showsuggestedArticlesStream: true,
}

export class AnalyzeContentComponentClass extends RasaReactComponent<any, State> {
  public chatEndRef;
  public chatInputRef;
  public static contextType = RasaContext;
  constructor(props: any) {
    super(props, 'communitySource', newState)
    this.sendMessage = this.sendMessage.bind(this)
    this.handleOnEnter = this.handleOnEnter.bind(this)
    this.chatEndRef = React.createRef()
    this.chatInputRef = React.createRef()
  }

  public componentDidMount = () => {
    this.context.user.init().then(({person, activeCommunity}) => {
      this.setState({
        activeCommunity,
        community: activeCommunity.communityId,
      })
    })
  }

  public render = () => {
    return (
      <div className="rex-wrapper">
        <div className="rex-wrapper_scroll" ref={this.chatEndRef}>
          <h1 className="rex-wrapper_heading"><AiAssistant svgwidth="50" svgheight="50"/>Rex</h1>
          {this.state.showDefaultPrompt && <h1 className="rex-wrapper_heading">Try asking me questions like:</h1>}
          <div className="rex-wrapper_list-msg">
            {this.state.showDefaultPrompt ? DEFAULT_PROMPTS.map((prompt, index) => {
              return (
                <div key={index} className='rex-wrapper-chat-item'>
                  <button onClick={() => this.executeDefaultPrompt(prompt)}
                          className="rex-wrapper_btn-list">{prompt.content}</button>
                </div>
              )
            }) : null}
            {
              this.state.prompts.map((prompt, index) => {
                return (
                  <div key={index} className='rex-wrapper-chat-item'>
                    {prompt.role === Constants.PROMPT_ROLE.USER ? <i className="rex-wrapper_img-list fa-user fa"></i> :
                      <i className="rex-wrapper_img-list"><AiAssistant svgwidth="30" svgheight="30"/></i>}
                    {this.buildPrompt(prompt)}
                  </div>
                )
              })
            }
            {this.state.articles.length > 0 ?
              <div>
                <div className='rex-wrapper-chat-item rex-chat-loader'>
                  <i className="rex-wrapper_img-list">
                    <AiAssistant svgwidth="30" svgheight="30"/>
                  </i>
                  <div className="rex-wrapper_msg-list">
                    <h3>Here are some articles you can add to your next newsletter.</h3>
                  </div>
                </div>
                <div className='rex-wrapper-chat-item rex-chat-loader'>
                  <i className="rex-wrapper_img-list">
                    <AiAssistant svgwidth="30" svgheight="30"/>
                  </i>
                  <div className="rex-wrapper_msg-list">
                    <div className='rex-wrapper-chat-item'>
                      <div className='rex-wrapper-article-list'>
                        {this.state.articles.map((article) => {
                          return <div className='rex-wrapper-article-item'>
                            <div className='rex-wrapper-article-image'>
                              {article.hosted_image_url ? <img src={article.hosted_image_url}/> : null}
                            </div>
                            <div className='rex-wrapper-article-info'>
                              <div className='rex-wrapper-article-title'>
                                <a href={article.url} target='_blank'>{article.title}</a>
                              </div>
                              <div className='rex-wrapper-article-description'>
                                {article.description.substring(0, 200)}
                              </div>
                              <div className='rex-wrapper-article-add'>
                                <button onClick={() => this.moveContentToUpcoming(article.post_id)}>Add to upcoming
                                </button>
                              </div>
                            </div>
                          </div>
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div> : null}
            {this.state.summary && this.state.showsummaryStream ? <div className='rex-wrapper-chat-item'>
              <i className="rex-wrapper_img-list">
                <AiAssistant svgwidth="30" svgheight="30"/>
              </i>
              {this.buildSummaryPrompt(this.state)}</div>: null}
            {this.state.suggestedArticles.length && this.state.showsuggestedArticlesStream ? <div className='rex-wrapper-chat-item'>
              <i className="rex-wrapper_img-list">
                <AiAssistant svgwidth="30" svgheight="30"/>
              </i>
              {this.buildSuggestedArticlesPrompt(this.state)}</div>: null}
            {this.state.streamMessage ?
              <div className='rex-wrapper-chat-item'>
                <i className="rex-wrapper_img-list">
                  <AiAssistant svgwidth="30" svgheight="30"/>
                </i>
                <div className="rex-wrapper_msg-list">
                  <p>
                    {this.state.streamMessage}
                  </p>
                </div>
              </div> : null}
          </div>
        </div>
        {this.state.showStreamLoader ?
          <div className='rex-wrapper-chat-item rex-chat-loader'>
            <i className="rex-wrapper_img-list">
              <AiAssistant svgwidth="30" svgheight="30"/>
            </i>
            <div className="rex-wrapper_msg-list">
              <p>
                <Loading size="16"></Loading>
              </p>
            </div>
          </div> : null}
        <div className="rex-wrapper_form-wrapper">
          <form action="#">
            <input type="text" ref={this.chatInputRef} onKeyDown={this.handleOnEnter} value={this.state.message}
                   onChange={(e) => this.setState({message: e.target.value})}
                   placeholder={this.state.chatInputPlaceholder} className="rex-wrapper_form-input"/>
            <button className="rex-wrapper_form-btn-submit">
              <PaperPlaneIcon onClick={this.sendMessage}/>
            </button>
          </form>
        </div>
      </div>
    )
  }

  private buildPrompt = (prompt) => {
    const promptJson = tryParseJSON(prompt.content)
    if (promptJson.summary) {
      return this.buildSummaryPrompt(promptJson)
    } else if (promptJson.articles && promptJson.articles.length > 0) {
      return this.buildArticlesPrompt(promptJson)
    } else if (promptJson.suggestedArticles && promptJson.suggestedArticles.length > 0) {
      return this.buildSuggestedArticlesPrompt(promptJson)
    } else {
      return this.buildMessagePrompt(prompt)
    }
  }

  private buildSuggestedArticlesPrompt = (prompt) => {
    return <div>
      <div className="rex-wrapper_msg-list">
        <h3>Do you want me to add {prompt.suggestedArticles.length > 1 ? 'these articles' : 'this article'} to your content pool?</h3>
        <div className='rex-wrapper-article-list'>
          {prompt.suggestedArticles.map((article) => <div className='rex-wrapper-article-item'>
            <div className='rex-wrapper-article-image'>
              {article.hosted_image_url ? <img src={article.hosted_image_url}/> : null}
            </div>
            <div className='rex-wrapper-article-info'>
              <div className='rex-wrapper-article-title'>
                <a href={article.url} target='_blank'>{article.title}</a>
              </div>
              <div className='rex-wrapper-article-description'>
                {article.description.substring(0, 200)}
              </div>
              <div className='rex-wrapper-article-add'>
                <button onClick={() => this.moveContentToUpcoming(article.post_id)}>Add to upcoming
                </button>
              </div>
            </div>
          </div>)}
        </div>
      </div>
    </div>
  }

  private buildMessagePrompt = (prompt) => {
    return <div className="rex-wrapper_msg-list">
      <p>{prompt.content}</p>
    </div>
  }

  private buildSummaryPrompt = (prompt) => {
    return <div className="rex-wrapper_msg-list">
      <p>
        <div>
          <div className="summary">
            <h2>Summary</h2>
            <span>{prompt.summary}</span>
          </div>
          {prompt.topics.length > 0 &&
            <div>
              <div className="summary">
                <h3>Topics</h3>
                <span>Topics related to this URL</span>
              </div>
              <div className="keywords">
                {prompt.topics.split(',').map((k: string, topicIndex: number) => (
                  <Badge className="keyword" key={`keyword-${topicIndex}`}>
                    <span>{k}</span>
                  </Badge>))}
              </div>
            </div>}
        </div>
      </p>
    </div>
  }

  private buildArticlesPrompt = (prompt) => {
    return <div>
      <div className="rex-wrapper_msg-list">
      <h3>Here are some articles you can add to your next newsletter.</h3>
      <div className='rex-wrapper-article-list'>
        {prompt.articles.map((article) => {
          return <div className='rex-wrapper-article-item'>
            <div className='rex-wrapper-article-image'>
              {article.hosted_image_url ? <img src={article.hosted_image_url}/> : null}
            </div>
            <div className='rex-wrapper-article-info'>
              <div className='rex-wrapper-article-title'>
                <a href={article.url} target='_blank'>{article.title}</a>
              </div>
              <div className='rex-wrapper-article-description'>
                {article.description.substring(0, 200)}
              </div>
              <div className='rex-wrapper-article-add'>
                <button onClick={() => this.moveContentToUpcoming(article.post_id)}>Add to upcoming
                </button>
              </div>
            </div>
          </div>
        })}
      </div>
    </div>
  </div>
  }

  private suggestContent = () => {
    this.setState({
      showStreamLoader: true,
    })
    const payload = {
      topics: this.state.topics,
      summary: this.state.summary,
      session_id: this.state.sessionId,
    }
    streamArticleResponse(this.state.community, payload, this.updateArticleResponse)
  }

  private scrollToBottom = () => {
    this.chatEndRef.current.scrollTop = this.chatEndRef.current.scrollHeight;
  }

  protected validInput(): boolean {
    return Validation.validateForgivingUrl(this.state.input).valid || Validation.validateDomain(this.state.input).valid
  }

  protected handleOnEnter(e) {
    if (e.key === 'Enter') {
      e.preventDefault()
      this.sendMessage()
    }
  }

  protected sendMessage = (message: string = "") => {
    this.setState({
      newPrompts: [
        ...this.state.newPrompts,
        {
          role: Constants.PROMPT_ROLE.USER,
          content: message ? message : this.state.message,
        }
      ],
      prompts:
        [
          ...this.state.prompts,
          {
            role: Constants.PROMPT_ROLE.USER,
            content: message ? message : this.state.message,
          }
        ],
      message: '',
      showStreamLoader: true,
      showDefaultPrompt: false,
      chatInputPlaceholder: '',
    }, () => {
      streamChatResponse(this.state.community, {
        prompts: this.state.newPrompts, 
        session_id: this.state.sessionId, 
        requires_confirmation: this.state.aiConfirmationType !== null
      }, 'suggest-content', this.updateChatMessage)
      this.scrollToBottom()
    })
  }

  private executeDefaultPrompt = (prompt: Prompt) => {
    // if prompt has some placeholder it means it requires user's input
    if (prompt.placeholder) {
      this.setState({
        prompts:
          [
            ...this.state.prompts,
            {
              role: prompt.role,
              content: prompt.content,
            }
          ],
        newPrompts: [
          ...this.state.newPrompts,
          {
            role: prompt.role,
            content: prompt.content,
          }
        ],
        chatInputPlaceholder: prompt.placeholder,
        showDefaultPrompt: false,
      })
      this.chatInputRef.current.focus()
    } else {
      this.setState({
        showDefaultPrompt: false,
      })
      this.sendMessage(prompt.content)
    }
  }

  private updateChatMessage: GenerativeAI.ChatCallback = (response: GenerativeAI.ChatResponse) => {
    if (!response) {
      this.setState({
        isSaving: false,
        newPrompts: [],
      })
    } else {
      if (response.done || response.error) {
        if (response.session_id) {
          this.setState({
            sessionId: response.session_id,
          })
        }
        let jsonString = response.message
        let aiJsonResponse = tryParseJSON(response.message)
        if (Object.keys(aiJsonResponse).length || this.state.aiJsonResponse) {
          if (Object.keys(aiJsonResponse).length === 0) {
            this.streamJson(response.message)
            jsonString = this.state.aiJsonResponse + response.message
            aiJsonResponse = tryParseJSON(jsonString)
          }
          if (aiJsonResponse) {
            if (aiJsonResponse.confirm) {
              this.takeConfirmationAction(aiJsonResponse.confirm)
              return
            }
            if (aiJsonResponse.suggestedArticles) {
              this.setState({
                aiConfirmationType: Constants.AIConfirmationType.ARTICLE_ADD,
                suggestedArticles: aiJsonResponse.suggestedArticles,
                showsuggestedArticlesStream: false,
              })
            }
            if (aiJsonResponse.rasaHelp === true) {
              this.setState({
                showStreamLoader: true,
              })
              streamChatResponse(this.state.community, {content: this.state.prompts[this.state.prompts.length-1].content}, 'help-content', this.updateKnowledgeMessage)
            } else if (aiJsonResponse.summary) {
              this.setState({
                prompts: [
                  ...this.state.prompts,
                  {
                    role: Constants.PROMPT_ROLE.ASSISTANT,
                    content: jsonString,
                  }, 
                ],
                aiJsonResponse: '',
                aiConfirmationType: Constants.AIConfirmationType.ARTICLE_SUGGESTION_REQUEST,
                showsummaryStream: false,
                showStreamLoader: false,
              }, () => {
                this.scrollToBottom()
                this.streamText("Do you want me to suggest content based on the given summary & topics?")
              })
            } else {
              this.setState({
                prompts: [
                  ...this.state.prompts,
                  {
                    role: Constants.PROMPT_ROLE.ASSISTANT,
                    content: jsonString,
                  }
                ],
                aiJsonResponse: '',
                showStreamLoader: false,
              })
            }
          }
        } else {
          this.setState({
            prompts: [
              ...this.state.prompts,
              {
                role: Constants.PROMPT_ROLE.ASSISTANT,
                content: this.state.streamMessage + response.message,
              }
            ],
            showStreamLoader: false,
          })
        }
        this.setState({
          isSaving: false,
          error: response.error,
          streamMessage: '',
          newPrompts: [],
        })
      } else {
        if (response.message) {
          if (response.message.startsWith('{') || this.state.aiJsonResponse) {
            this.streamJson(response.message)
            this.setState({
              aiJsonResponse: this.state.aiJsonResponse + response.message,
              showStreamLoader: false,
            })
          } else {
            this.setState({
              streamMessage: this.state.streamMessage + response.message,
              showStreamLoader: false,
            })
          }
        }
      }
      this.scrollToBottom()
    }
  }

  private updateKnowledgeMessage= (response: GenerativeAI.ChatResponse) => {
    if (!response ) {
      this.setState({
        prompts: [
          ...this.state.prompts,
          {
            role: Constants.PROMPT_ROLE.ASSISTANT,
            content: this.state.streamMessage,
          }
        ],
        streamMessage: '',
        aiJsonResponse: '',
        showStreamLoader: false,
      })
    } else {
      this.setState({
        streamMessage: this.state.streamMessage + response.message,
        showStreamLoader: false,
      })
      this.scrollToBottom()
    }
  }

  private updateArticleResponse: GenerativeAI.ChatCallback = (response: GenerativeAI.ChatResponse) => {
    if ( !response ) {
      this.setState({
        isSaving: false,
        showDefaultPrompt: false,
        showStreamLoader: false,
        chatInputPlaceholder: '',
        aiConfirmationType: null,
      })
    } else {
      const articleJson = tryParseJSON(response.message)
      if (response.done) {
        const articles = [
          ...this.state.articles,
          articleJson,
        ]
        this.setState({
          prompts: [
            ...this.state.prompts, 
            {
              role: Constants.PROMPT_ROLE.ASSISTANT,
              content: JSON.stringify({
                articles
              }),
            },
          ],
          articles: [],
        }, () => {
          this.scrollToBottom()
        })
      } else if ( articleJson ) {
        this.setState({
          articles: [
            ...this.state.articles,
            articleJson,
          ],
          isSaving: false,
          showStreamLoader: false,
        }, () => {
          this.scrollToBottom()
        })
      }
      this.scrollToBottom()
    }
  }

  private moveContentToUpcoming = (post_ids) => {
    this.setState({
      isLoading: true,
    })
    return this.context.entityMetadata.getEntityObject('communityArticle').then((entity) => {
      entity.setRecordId(this.state.activeCommunity.communityId, null);
      entity.data.post_ids = post_ids.toString()
      if (isInCutoffWindow(this.state.activeCommunity.nextIssue)) {
        entity.data.boost_level = NORMAL_BOOSTED_BOOST_LEVEL
        entity.data.created = this.state.activeCommunity.nextIssue.cutoff
      }
      return entity.save()
        .then(() => {
          this.setState({
            isLoading: false,
          })
          this.setState({
            suggestedArticles: [],
            aiConfirmationType: null,
            showStreamLoader: false
          })
          this.streamText('Article has been successfully added to your contet pool.')
        })
        .catch(() => {
        })
    })
  }

  private sendManualMessage = (message: string, addToQueue: boolean) => {
    this.setState({
      prompts:
        [
          ...this.state.prompts,
          {
            role: Constants.PROMPT_ROLE.ASSISTANT,
            content: message,
          }
        ],
    }, () => {
      this.scrollToBottom()
    })
    if (addToQueue) {
      this.setState({
        newPrompts: [
          ...this.state.newPrompts,
          {
            role: Constants.PROMPT_ROLE.ASSISTANT,
            content: message,
          }
        ],
      }, () => {
        this.scrollToBottom()
      })
    }
  }

  private takeConfirmationAction = (confirm) => {

    if (this.state.aiConfirmationType === Constants.AIConfirmationType.ARTICLE_ADD) {
      if (isTruthy(confirm)) {
        this.moveContentToUpcoming(this.state.suggestedArticles.map((article) => article.post_id))
      } else {
        this.sendManualMessage('Ok. Is there anything else I can help you with?', true)
      }
    } else if (this.state.aiConfirmationType === Constants.AIConfirmationType.ARTICLE_SUGGESTION_REQUEST) {
      if (isTruthy(confirm)) {
        this.suggestContent()
      } else {
        this.sendMessage(Constants.EXPLORE_MORE_PROMPT.content)
      }
    }
  }

  private streamJson = (jsonStream: string) => {
    const pickTriggers = [
      "{\"",
      ".\","
    ]
    const ignoreStreamData = [
      ...pickTriggers,
      "\":",
      " \"",
      "\"}",
    ]
    if (pickTriggers.includes(jsonStream)) {
      this.setState({
        pickStreamKey: true,
      })
    } else if (ignoreStreamData.includes(jsonStream)) {
      return
    } else {
      if (this.state.pickStreamKey) {
        this.setState({
          ...this.state,
          [`show${this.state.pickStreamKey}Stream`]: true,
          currentStreamKey: jsonStream,
          pickStreamKey: false,
        })
      } else {
        this.setState({
          ...this.state,
          showStreamLoader: false,
          [this.state.currentStreamKey]: this.state[this.state.currentStreamKey] + jsonStream,
        }, () => {
          this.scrollToBottom()
        })
      }
    }
  }

  private delay = (ms: number) => {
    return new Promise((resolve) => {
      setTimeout(resolve, ms)
    })
  }

  private streamText = (text) => {
    const TEXT_STREAM_DELAY = 100
    const words = text.split(' ')
    return words.forEach((word, index) => {
      this.delay(TEXT_STREAM_DELAY * (index + 1)).then(() => {
        if (index === words.length - 1) {
          this.setState({
            streamMessage: '',
            prompts: [
              ...this.state.prompts,
              {
                role: Constants.PROMPT_ROLE.ASSISTANT,
                content: `${this.state.streamMessage} ${word}`,
              }
            ],
          }, () => {
            this.scrollToBottom()
          })
        } else {
          this.setState({
            streamMessage: `${this.state.streamMessage} ${word}`,
          }, () => {
            this.scrollToBottom()
          })
        }
      })
    })
  }
}
